import { httpRequest } from "../../http";
import { CatalogCoreFieldSample } from "@models/catalog.model";

export class CommandListCoreFieldSamples {
  // A vertical's per-role doc-copy (sample + description) for the standard core fields (MPN-1233).
  async run(verticalCode: string): Promise<CatalogCoreFieldSample[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/${encodeURIComponent(verticalCode)}/core-field-samples/`;
    return httpRequest<CatalogCoreFieldSample[]>(url, { method: "GET" });
  }
}
